import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
// import { Router, Route, IndexRoute, Redirect, hashHistory } from 'react-router';

//import App from './app'
// import AuthOrApp from './authOrApp';
import Dashboard from '../dashboard/dashboard';

import CadUsuario from '../usuario/usuario';
import CadControlador from '../controlador/controlador';
import ControladorHistoricoManutencaoPage from '../controlador/controladorHistoricoManutencaoPage';
import CadGrupo from '../grupo/grupo';
import CadFase from '../fase/fase';
import CadPlano from '../plano/plano';
import CadTrocaPlano from '../troca_plano/trocaPlano';
import CadDataEspecial from '../data_especial/dataEspecial';
import CadIntervaloPlano from '../intervalo/intervalo';
import CadSelecaoAutomatica from '../sap/selecaoAutomatica';
import CadDetector from '../detector/detector';
import CadTipoAlarme from '../tipo_alarme/tipoAlarme';
import CadGrupoFisico from '../grupo_fisico/grupoFisico';
import MapaDeFases from '../fase/mapaFaseGeral';
import ConControladorErro from '../controlador_erro/erro';
import ContagemVolumetrica from '../contagem_volumetrica/contagemVolumetrica';
import CadAdaptativo from '../adaptativo/adaptativo';
import ExecPlanoForcado from '../plano_forcado/planoForcado';
import ConControladorErroGeral from '../controlador_erro_geral/erroGeral';
import ConLogUsuario from '../log_usuario/logUsuario';
import CadIdentificadorTelegram from '../telegram/identificadorTelegram';
import TicketSuporteList from '../ticket_suporte/ticketSuporteList';
import OrdemServico from '../manutencao/ordem_servico/ordemServico';
import Estoque from '../manutencao/estoque/estoque';
import Equipe from '../manutencao/equipe/equipe';
import Viatura from '../manutencao/viatura/viatura';
import MapaOrdemServico from '../manutencao/mapa/mapaOrdemServico';
import MapaViaturas from '../manutencao/mapa/mapaViaturas';
import Inventario from '../manutencao/inventario/inventario';

import TrocaPlano from '../troca_plano/trocaPlano';
import LogUsuario from '../log_usuario/logUsuario';
import LogAdaptativo from '../log_adaptativo/logAdaptativo';
import Pluviometro from '../pluviometro/pluviometro';
import PluviometroTempoReal from '../pluviometro/pluviometroTempoReal';
import PluviometroHistorico from '../pluviometro/pluviometroHistorico';
import PluviometroMapa from '../pluviometro/pluviometroMapa';
import CameraAccess from '../camera/cameraAccess';
import CameraCadastro from '../camera/camera';
import Transito from '../trafego/transito';
import MapaWaze from '../waze/mapaWaze';
// import ListContagem from '../contagem/graficoContagem'; se não é chamado por menu, não tem rota

export default props => (
  <div className="content-wrapper">
    <Switch>
      <Route exact path="/" component={Dashboard} />

      <Route path="/cadusuario" component={CadUsuario} />
      <Route path="/cadcontrolador" component={CadControlador} />
      <Route path="/controlador-manutencao/:id" component={ControladorHistoricoManutencaoPage} />
      <Route path="/cadgrupo" component={CadGrupo} />
      <Route path="/cadfase" component={CadFase} />
      <Route path="/cadplano" component={CadPlano} />
      <Route path="/cadtrocaplano" component={CadTrocaPlano} />
      <Route path="/caddataespecial" component={CadDataEspecial} />
      <Route path="/cadintervaloplano" component={CadIntervaloPlano} />
      <Route path="/cadselecaoautomatica" component={CadSelecaoAutomatica} />
      <Route path="/caddetector" component={CadDetector} />
      <Route path="/cadtipoalarme" component={CadTipoAlarme} />
      <Route path="/cadgrupofisico" component={CadGrupoFisico} />
      <Route path="/mapadefases" component={MapaDeFases} />
      <Route path="/transito" component={Transito} />
      <Route path="/mapa-waze" component={MapaWaze} />
      <Route path="/concontroladorerro" component={ConControladorErro} />
      <Route path="/contagemvolumetrica" component={ContagemVolumetrica} />
      <Route path="/cadadaptativo" component={CadAdaptativo} />
      <Route path="/execplanoforcado" component={ExecPlanoForcado} />
      <Route path="/concontroladorerrogeral" component={ConControladorErroGeral} />
      <Route path="/conlogusuario" component={ConLogUsuario} />

      <Route path="/telegram" component={CadIdentificadorTelegram} />

      <Route path="/ticketsuporte" component={TicketSuporteList} />

      <Route path="/manutencao-os" component={OrdemServico} />
      <Route path="/manutencao-estoque" component={Estoque} />
      <Route path="/manutencao-equipes" component={Equipe} />
      <Route path="/manutencao-viaturas" component={Viatura} />
      <Route path="/manutencao-mapa" component={MapaOrdemServico} />
      <Route path="/manutencao-mapa-viaturas" component={MapaViaturas} />
      <Route path="/manutencao-inventario" component={Inventario} />

      <Route path="/trocaplano" component={TrocaPlano} />
      <Route path="/logusuario" component={LogUsuario} />
      <Route path="/log-adaptativo" component={LogAdaptativo} />
      <Route path="/pluviometro" component={Pluviometro} />
      <Route path="/pluviometro-tempo-real" component={PluviometroTempoReal} />
      <Route path="/pluviometro-historico" component={PluviometroHistorico} />
      <Route path="/pluviometro-mapa" component={PluviometroMapa} />

      <Route path="/cameradeteccao" render={() => <CameraAccess type="deteccao" />} />
      <Route path="/cameramonitoramento" render={() => <CameraAccess type="monitoramento" />} />
      <Route path="/cadcamera" component={CameraCadastro} />

      <Redirect from="*" to="/" />
    </Switch>
  </div>
);
